module.exports = __webpack_public_path__ + "static/pic03.68cd4e8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic03.jpg
// module id = 514
// module chunks = 35783957827783